exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.tw-news_news_2xF72 {\r\n    background: var(--motion-tertiary);\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0.375rem 0;\r\n    gap: 0.5rem;\r\n}\r\n\r\n.tw-news_text_1OE4I {\r\n    flex-grow: 1;\r\n    color: white;\r\n    text-align: center;\r\n}\r\n\r\n.tw-news_text_1OE4I a {\r\n    color: inherit;\r\n}\r\n\r\n.tw-news_close_3iAN3 {\r\n    flex-shrink: 0;\r\n    margin-right: 0.5rem;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"news": "tw-news_news_2xF72",
	"text": "tw-news_text_1OE4I",
	"close": "tw-news_close_3iAN3"
};